import React, { useEffect, useState } from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { useLocation, useNavigate } from 'react-router-dom';
import gymLogo from '../../components/images/Easy-MembrLogo.png';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { getBussinessInfobyUrl, verifyNumber, saveUser, getGBussinessInfo } from '../../services/memberApiServices';
import DigitalWaiver from '../../views/DigitalWaiver';
import MemberWaiver from '../components/MemberWaiver';
import { useAnalytics } from '../../hooks/useAnalytics';


const MemberSignup = () => {
    const { trackButtonClick } = useAnalytics();
    const [step, setStep] = useState(1);
    const [number, setnumber] = useState('');
    const [otp, setOtp] = useState('');
    const [countdown, setCountdown] = useState(60);
    const [error, setError] = useState('');
    const [notp, setNotp] = useState("");
    const [verify, setVerify] = useState(false);
    const [fname, setfname] = useState('');
    const [lname, setlname] = useState('');
    const [email, setEmail] = useState('');
    const [bussinessinfo, setBusinessInfo] = useState(null);
    const navigate = useNavigate();
    const { state } = useLocation();
    console.log(state, 'stategjh');

    const hostname = window.location.hostname;
    let subdomain = "";

    if (hostname.endsWith('easymembr.com') || hostname.endsWith('zencruz.com')) {
        const parts = hostname.split('.');
        if (parts.length === 3 && parts[0] !== 'www' && parts[0] !== "app" && parts[0] !== "beta") {
            subdomain = parts[0];
        }
    }

    useEffect(() => {
        const fetchBusiness = async () => {
            const identifier = subdomain;
            const type = subdomain ? 'subdomain' : 'prefix';

            const response = await getBussinessInfobyUrl(identifier, type);
            // const response = await getGBussinessInfo(
            //     "67502055bfca0b906a81dfbe"
            // );
            if (!response || response === "false") {
                return;
            }

            const businessInfo = await response.json();
            console.log(businessInfo);
            setBusinessInfo(businessInfo);
        };

        if (subdomain !== "") {
            fetchBusiness();
        }
    }, [subdomain]);

    const handleMobileSubmit = async (e) => {
        e.preventDefault();
        if (!isValidPhoneNumber(number)) {
            setError("Please enter valid contact number!");
            return;
        }

        const response = await verifyNumber({ phone: number });
        let resData = await response.json();

        if (resData.status !== 200) {
            setError("Please try again.");
            return;
        }

        setError("");
        setNotp(resData.otp);
        setStep(2);
        startCountdown();
    };

    const handleSignupSubmit = async (e) => {
        e.preventDefault();

        if (!fname || !lname || !email || !number) {
            setError("Please fill all fields");
            return;
        }

        if (!isValidPhoneNumber(number)) {
            setError("Please enter valid contact number!");
            return;
        }

        if (otp !== notp) {
            setError("Invalid OTP. Please try again.");
            return;
        }

        try {
            const memberData = {
                fname,
                lname,
                email,
                number: number,
                // fallback gym ID
            };


            const response = await saveUser(memberData, bussinessinfo?._id);
            const data = await response.json();
            console.log(data, 'data');

            if (data) {
                const update = {
                    gymid: bussinessinfo?._id,
                    number: number,
                    // memberId: data.val._id,
                };


                const memberinfoObj = {
                    number: data.val.number,
                    username: `${data.val.fname} ${data.val.lname}`,
                    fname: data.val.fname || null,
                    lname: data.val.lname || null,
                    imgurl: data.val.imgurl || null,
                    gymid: data.val.bId || -1,
                    id: data.val._id || -1,
                };

                
                localStorage.setItem("loggedMemberInfo", JSON.stringify(update));
                localStorage.setItem("memberinfo", JSON.stringify(memberinfoObj));

                const savedPath =
                    state?.path ||
                    localStorage.getItem("redirectPath") ||
                    localStorage.getItem("pendingRedirectUrl");

                console.log("savedPath", savedPath);

                if (savedPath) {
                    navigate(savedPath);
                    localStorage.removeItem("redirectPath");
                    localStorage.removeItem("pendingRedirectUrl");
                } else {
                    navigate('/memberdashboard');
                }

            } else {
                setError(data.message || "Registration failed. Please try again.");
            }
        } catch (err) {
            setError("An error occurred. Please try again.");
            console.error(err);
        }
    };




    const startCountdown = () => {
        setCountdown(60);
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    // const resendOtp = (e) => {
    //     startCountdown();
    //     setOtp('');
    //     handleMobileSubmit(e);
    // };
    console.log(localStorage.getItem("redirectPath"));

    const callbackHandler = (info) => {
        console.log(info, 'info');

        // Support both response formats:
        // Old (createWaiver): info.waiverDetails = { mId, gymid, phone, fname, lname, imgurl }
        // New (createMultiWaiverForms): info.members[0].id + info.primaryParticipant + info.gymid
        const waiverDetails = info?.waiverDetails || {};
        const primaryMember = info?.members?.[0];
        const primaryParticipant = info?.primaryParticipant || {};

        const memberId = waiverDetails?.mId || primaryMember?.id || -1;
        const gymId = waiverDetails?.gymid || info?.gymid || bussinessinfo?._id || "";
        const phone = waiverDetails?.phone || primaryParticipant?.phone || "";
        const fname = waiverDetails?.fname || primaryParticipant?.fname || "";
        const lname = waiverDetails?.lname || primaryParticipant?.lname || "";
        const imgurl = waiverDetails?.imgurl || primaryParticipant?.imgurl || "";

        const loggedupdate = {
            gymid: gymId,
            number: phone
        };
        localStorage.setItem("loggedMemberInfo", JSON.stringify(loggedupdate));

        const memberinfoObj = {
            number: phone,
            username: fname ? fname + " " + lname : null,
            fname: fname || null,
            lname: lname || null,
            imgurl: imgurl || null,
            gymid: gymId || -1,
            id: memberId,
        };

        trackButtonClick("MemberSignup", "Member_Signup", "member", {});
        localStorage.setItem("memberinfo", JSON.stringify(memberinfoObj));

        const savedPath = state?.path || localStorage.getItem("redirectPath");
        if (savedPath) {
            navigate(savedPath);
            localStorage.removeItem("redirectPath");
        } else {
            navigate('/memberdashboard');
        }
    }


    const resendOtp = (e) => {
        startCountdown();
        setOtp('');
        handleMobileSubmit(e);
    };


    return (
        <>
            {state?.waiverstatus ===true ? (
                <MemberWaiver
                    logourl={bussinessinfo?.logourl}
                    gymid={bussinessinfo?._id ? bussinessinfo?._id : -1}
                    onWaiverSubmitted={callbackHandler}
                />
            ) : (
                <div className="member-singuppage row">
                    <MDBCard className="shadow-5 col-12 col-md-6 col-lg-5 col-xl-4 p-0">
                        <MDBCardBody className=" px-5 text-center">
                            <div className='memberloginheader mb-4 '>
                                <img
                                    src={gymLogo}
                                    className='membergym-logo'
                                    alt="Gym Logo" />
                                <div className='position-relative'>
                                    <div className='log-content'>
                                        <h5 className="mb-0">Member </h5>
                                        <h4>Sign Up</h4>
                                    </div>
                                    <span className='login-line'></span>
                                </div>
                            </div>

                            {step === 1 ? (
                                <form onSubmit={handleMobileSubmit}>
                                    <div className="text-start  row">
                                        <div className='col-12 mb-2 col-md-6'>
                                            <label className="form-label text-dark fw-bold mb-1">First Name</label>
                                            <MDBInput
                                                type="text"
                                                value={fname}
                                                onChange={(e) => setfname(e.target.value)}
                                                placeholder="Enter your first name"
                                                size="lg"
                                            />
                                        </div>
                                        <div className='col-12 mb-2 col-md-6'>
                                            <label className="form-label text-dark fw-bold mb-1">Last Name</label>
                                            <MDBInput
                                                type="text"
                                                value={lname}
                                                onChange={(e) => setlname(e.target.value)}
                                                placeholder="Enter your last name"
                                                size="lg"
                                            />
                                        </div>
                                        <div className='col-12 mb-2 col-md-12'>
                                            <label className="form-label text-dark fw-bold mb-1">Email</label>
                                            <MDBInput
                                                type="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder="Enter your email"
                                                size="lg"
                                            />
                                        </div>
                                        <div className='col-12 col-md-12'>
                                            <label className="form-label text-dark fw-bold mb-1">Mobile number</label>
                                            <PhoneInput
                                                className="form-control input-mobile"
                                                size="lg"
                                                defaultCountry="IN"
                                                placeholder="10-digit mobile number"
                                                value={number}
                                                onInput={(e) => e.target.value = e.target.value.slice(0, 15)}
                                                onChange={setnumber}
                                            />

                                            {error && <div className="text-danger small mt-2">{error}</div>}
                                        </div>
                                        <label className="form-label pt-1 text-secondary">
                                            We'll send a one-time password to your mobile
                                        </label>
                                    </div>

                                    <MDBBtn
                                        type="submit"
                                        className="nav-btn logbtn"
                                        color="primary"
                                        block
                                        disabled={!fname || !lname || !email || !number}
                                    >
                                        <span> Send OTP</span>
                                    </MDBBtn>

                                    <p className="text-muted pt-3 d-flex justify-content-end align-items-center">
                                        Already have an account? <a href="/memberlogin" className='ps-2 pe-0' style={{ fontSize: '13.8px' }}> <u>Login here</u></a>
                                    </p>
                                </form>
                            ) : (
                                <form onSubmit={handleSignupSubmit}>
                                    <div className="text-start row">
                                        {error && <div className="text-danger small mb-2">{error}</div>}

                                        <div className="col-12 mb-2 col-md-12">
                                            <label className="form-label text-dark fw-bold mb-1">OTP</label>
                                            <MDBInput
                                                type="tel"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                placeholder="6-Digit OTP"
                                                maxLength="6"
                                                className="text-center letter-spacing input-mobile"
                                                style={{ letterSpacing: '1px', fontSize: '1.2rem' }}
                                            />
                                            <label className="form-label pt-1 mb-0 text-secondary">
                                                Enter the 6-Digit OTP sent to ******{number.slice(-4)}
                                            </label>
                                        </div>

                                        <div className="col-12 mb-2 col-md-6">
                                            <label className="form-label text-dark fw-bold mb-1">First Name</label>
                                            <MDBInput
                                                type="text"
                                                value={fname}
                                                readOnly
                                                className="bg-light"
                                                size="lg"
                                            />
                                        </div>

                                        <div className="col-12 mb-2 col-md-6">
                                            <label className="form-label text-dark fw-bold mb-1">Last Name</label>
                                            <MDBInput
                                                type="text"
                                                value={lname}
                                                readOnly
                                                className="bg-light"
                                                size="lg"
                                            />
                                        </div>

                                        <div className="col-12 mb-2 col-md-12">
                                            <label className="form-label text-dark fw-bold mb-1">Email</label>
                                            <MDBInput
                                                type="email"
                                                value={email}
                                                readOnly
                                                className="bg-light"
                                                size="lg"
                                            />
                                        </div>
                                    </div>

                                    <MDBBtn
                                        type="submit"
                                        color="primary"
                                        className="nav-btn logbtn"
                                        block
                                        disabled={otp.length !== 6}
                                    >
                                        <span> Complete Sign Up</span>
                                    </MDBBtn>

                                    <div className="d-flex justify-content-between py-2 virify-btn">
                                        <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            onClick={() => setStep(1)}
                                        >
                                            Change Number
                                        </button>

                                        {countdown > 0 ? (
                                            <span className="text-muted">
                                                Resend OTP in <span className='text-danger'> {countdown} s</span>
                                            </span>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                onClick={(e) => resendOtp(e)}
                                            >
                                                <u> Resend OTP</u>
                                            </button>
                                        )}
                                    </div>
                                </form>
                            )}

                            <div className="mt-4 ">
                                <p className="text-muted supp-footer m-0">
                                    <span>Having trouble?</span> <a href="/contactus"><u><MDBIcon fas icon="headset" className='me-1' /> Contact support</u></a>
                                </p>
                            </div>
                        </MDBCardBody>
                    </MDBCard>
                </div>
            )}
        </>
    );
};

export default MemberSignup;



